<template>
    <div>
      <Breadcrumbs :title="project ? project.translation['en'].name + ' / EntreComp: The Entrepreneurship Competence Framework' : '&nbsp;'"/>

        <div class="container-fluid">
<!--            <h5 style="line-height: 30px;">EntreComp: The Entrepreneurship Competence Framework</h5>-->

            <CompetencesSum :modules="modules" v-if="competences.length"></CompetencesSum>

            <div class="card mt-4" style="padding: 30px 50px !important;" v-for="module in modules" :key="module.id">
                <div class="card-header">
                    <h5 style="line-height: 30px;">{{ module.name }}</h5>
                </div>
                <div class="card-body">
                    <div v-for="item in module.items" :key="item.id" class="mt-4">

                        <div style="font-size: 16px"><b>{{ item.translation['en'].name }}</b></div>

                        <table role="table" aria-busy="false" aria-colcount="4"
                               class="table b-table table-xl table-striped table-hover mt-4">
                            <tbody role="rowgroup">
                            <CompetencesRow :row="row" v-for="row in item.items" :key="row.id"></CompetencesRow>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

import CompetencesRow from "@/pages/Projects/ProjectCompetences/CompetencesRow";
import CompetencesSum from "@/pages/Projects/ProjectCompetences/CompetencesSum";

export default {
    components: {CompetencesSum, CompetencesRow},
    data() {
        return {
            competences: [],
            project: null
        };
    },
    async created() {

        this.competences = await this.$store.dispatch('projects/getCompetences', this.$route.params.id)
        this.project = await this.$store.dispatch('projects/getProject', this.$route.params.id)
        this.$store.dispatch('shared/setLoading', false)
    },
    methods: {
        setItems(modules, index) {

            modules[index].items = this.competences.filter((item) => {
                return item.parent_id == (index + 1)
            })

            modules[index].items.sort((a, b) => a.order - b.order || a.id - b.id);

            modules[index].items.forEach((record) => {
                record.items = this.competences.filter((item) => {
                    return item.parent_id == record.id
                })
            })

            return modules
        }
    },
    computed: {
        modules: function () {

            let modules = [
                {
                    id: 1,
                    name: 'Ideas & Opportunities'
                },
                {
                    id: 2,
                    name: 'Resources'
                },
                {
                    id: 3,
                    name: 'Into Action'
                }
            ]

            modules = this.setItems(modules, 0);
            modules = this.setItems(modules, 1);
            modules = this.setItems(modules, 2);

            return modules
        },
        locale: function () {
            return this.$i18n.locale
        }
    }
}

</script>

<style>

.card h5 {
    color: #7366ff;
}

.main-menu .nav-item {
    cursor: pointer;
}

.step-selected {
    background-color: rgba(115, 102, 255, 0.15);
    -webkit-transition: all 0.5s ease;
    transition: all 0.5s ease;
    color: #7366ff;
}

.card-description * {
    color: #2c323f !important;
}

</style>